import { ViboThemeEnum } from './interfaces';

export const VIBO_THEME_NAME = 'vibo_theme';

export const VIBO_THEMES = [ViboThemeEnum.light, ViboThemeEnum.dark];

export const DEFAULT_VIBO_COLOR = 210;
